export class cabecalhoDTO {
    nome: string;
    ordem: number;
    icone: string;
    constructor(nome: string="",ordem: number,icone:string) {
        this.nome = nome;
        this.ordem = ordem;
        this.icone = icone;
    }
}